import { render, staticRenderFns } from "./App.vue?vue&type=template&id=860fd6e8&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./App.vue?vue&type=style&index=0&id=860fd6e8&prod&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=860fd6e8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860fd6e8",
  null
  
)

export default component.exports